// extracted by mini-css-extract-plugin
module.exports = {"alarmsMenu":"styles_alarmsMenu__VtP1d"};